import React from "react";
import chessslogo from "../../images/chessslogo.png";

function MobileNewsSummary() {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '100%',
      padding: '15px',
      boxSizing: 'border-box'
    }}>  
      <div style={{ 
        color: 'gold', 
        fontSize: '14px', 
        fontWeight: '', 
        textAlign: 'center', 
        // borderBottom: '2px solid gold',
        paddingBottom: '5px'
      }}>
        CREATE CHESS CONTENT ON 
      </div>
      <div
      style={{ fontFamily: 'mansalva', color: 'gold', fontSize: '24px' }}
      >
        ChessThread
      </div>
      

      
      <img 
        src={chessslogo} 
        alt="Chess Logo" 
        style={{ 
          width: '70px', 
          height: '70px', 
          marginBottom: '10px' 
        }} 
      />
      
      <button 
        style={{ 
          background: 'black',
          border: '2px solid gold',
          color: 'gold',
          borderRadius: '6px',
          padding: '8px',
          fontSize: '11px',
          fontWeight: 'bold',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          width: '100%',
          textAlign: 'center'
        }}
        onClick={() => {
          window.location.href = '/Analysis';
        }}
        onTouchStart={(e) => {
          e.currentTarget.style.backgroundColor = 'gold';
          e.currentTarget.style.color = 'black';
        }}
        onTouchEnd={(e) => {
          e.currentTarget.style.backgroundColor = 'black';
          e.currentTarget.style.color = 'gold';
        }}
      >
        START CREATING
      </button>
    </div>
  );
}

export default MobileNewsSummary;